/* eslint-disable max-len */

// General Variables
export const HOST = 'https://www.homedepot.com';
export const RELATIVE_CART_URL = '/cart';
export const PAGE_TYPE = {
  SERVICES: 'services',
  PROTECTION: 'protection',
  CONFIRMATION: 'confirmation',
  HAUL_AWAY: 'haulAway'
};

export const DEFAULT_QUERY_VARIABLES = {
  storeId: '121',
  storeZip: '30339'
};

export const HOME_DEPOT_DOMAINS = [
  'https://www.homedepot.com',
  'https://hd-qa74.homedepotdev.com'
];

// Conditional Variables
export const ADD_ON_CATEGORIES = {
  HAUL_AWAY: ['optional'],
  INSTALLATION: ['required', 'applianceConfig'],
  PROTECTION: ['protectionPlan'],
};

export const ADD_ON_TYPES = {
  HAUL_AWAY: ['Service'],
  INSTALLATION: ['Install'],
  PROTECTION: ['protectionPlan'],
};

export const CHECKOUT_ADD_ON_CATEGORIES = {
  HAUL_AWAY: ['optional'],
  INSTALLATION: ['required'],
  CONFIG: ['applianceConfig'],
  REQUIRED: ['required'],
  PROTECTION: ['protectionPlan']
};

export const CHECKOUT_ADD_ON_TYPES = {
  HAUL_AWAY: ['SERVICE'],
  INSTALLATION: ['INSTALL'],
  CONFIG: [null],
  REQUIRED: ['PART'],
  PROTECTION: ['protectionPlan']
};

// Config attribute identifiers
export const CONFIG_ATTRS = {
  HAUL_AWAY: '174602',
  MOVE: '853290',
  HOOKUP: 'Hookup',
  CONFIGURED: 'Configured'
};

// Config attribute identifiers to ignore when determining cheapest add-on
export const CONFIG_ATTRS_CHEAPEST_IGNORE = ['175306'];

// Header Variables
export const HEADER_TITLES = {
  PROTECTION: 'Home Depot Protection Plan',
  SERVICES: 'Installation & Haul Away Services',
  SUCCESS: 'Added To Cart'
};

// Protection Plans
export const PROTECTION_DETAILS_URL = `${HOST}/c/Home_Depot_Protection_Plan_Coverage_Details#majorappliances`;
export const PROTECTION_NOTE = 'Note: You can review each appliance manufacturer\'s warranty, included in the original price, on the product page under the "Additional Resources" section.';
export const PROTECTION_TITLE = 'let’s review your coverage options.';
export const PROTECTION_EMPTY = 'Home Depot Protection Plan is not available for this item';

// Installation Options
export const INSTALL_OPTIONS = {
  ACCEPT: 'install-accept',
  DECLINE: 'install-decline'
};
export const INSTALL_POPOVER = {
  TEXT: ({ isPlural }) => `${isPlural ? 'These parts are' : 'This part is'} needed to install your appliance. You may void the manufacturer's warranty if you use ${isPlural ? 'different parts' : 'a different part'}.`,
  TITLE: ({ isPlural }) => `Why ${isPlural ? 'Are These' : 'Is This'} Required?`
};
export const INSTALL_REQUIREMENTS_URL = `${HOST}/c/Appliance_Delivery_Installation`;
export const INSTALL_STANDARD_KIT_TEXT = 'Standard Installation Kit (required)';
export const INSTALL_TEXT = 'Installation';
export const INSTALL_TITLE = 'let’s review your installation options.';
export const INSTALL_EMPTY = 'This item doesn’t qualify for Installation Services';
export const INSTALL_TWO_STEP = 'The area you live in requires a licensed installer to install your appliance. Home Depot will deliver the appliance to your address, and you will then be contacted to schedule a follow-up installation at a later date. Delivery and installation are all covered as part of the installation cost.';
export const INSTALL_NOT_AVAILABLE = 'Installation is not available for this item.';

export const INSTALL_ITEM_CONFIGURED = {
  category: 'applianceConfig',
  configAttr: 'Configured'
};

// Fulfillment Methods for Compatible Products
export const FULFILLMENT_METHOD = {
  STH: 'ShipToHome',
  BOPIS: 'BOPIS'
};

// Haul Away Options
export const HAULAWAY_EMPTY = 'Haul Away & Move is not available for this item';
export const HAULAWAY_NOT_QUALIFY = 'This item does not qualify for Haul Away and Move Services.';

// Pricing
export const TAX_MESSAGING = 'Taxes are calculated during checkout.';

export const PARTS_AND_SERVICES_ERROR_MSG = 'Errors from dependency service';
export const PARTS_AND_SERVICES_DOWN_ALERT_MSG = 'The Home Depot Protection Plan, Installation and Haul Away services are temporarily unavailable. Try adding the services in cart or contact Customer Service after your purchase at 1-800-430-3376.';

// Info Alert Options
export const INFO_ALERT_PROTECTION = 'Please review and finalize your protection selections before checking out.';
export const INFO_ALERT_SERVICES = 'Please review and finalize your installation selections before checking out.';
export const INFO_ALERT_SELECTIONS = 'Make selections for Parts and Services based on your new zip code.';
export const INFO_ALERT_BOPIS = 'Standard Home Depot Installation and Haul Away services aren\'t available when picking up appliances in store. Select "Add In-Home installation" below to get connected with a local pro.';

export const POST_MESSAGE = {
  OPENED: 'PARTS_AND_SERVICES_OPENED',
  CHECKOUT: 'PARTS_AND_SERVICES_CHECKOUT',
  CLOSED: 'PARTS_AND_SERVICES_CLOSED',
  CONTINUE: 'PARTS_AND_SERVICES_CONTINUE'
};

export const DROPDOWN_CONTAINER_TITLE = 'Choose Installation and Coverage Options';
export const PROTECTION_TEXT = 'Protection Plan';
export const HAUL_AWAY_TEXT = 'Haul Away & Move';

export const INSTALLATION_REQUIRED = 'Required Parts for Installation';
export const SELECTED_INSTALLATION = 'Selected: Installation and Required Parts';
export const STARTING_FROM = 'Starting from';
export const HAUL_AWAY_AND_MOVE = 'Selected: Haul Away and Move';
export const HAUL_AWAY = 'Selected: Haul Away';
export const MOVE = 'Selected: Move';
export const TARGET_ORIGIN = 'window.location.origin';

export const BOPIS_ALERT = 'Select Delivery to add installation and protection plans to your order.';